module.exports = __webpack_public_path__ + "images/emoji/video_camera.b3c2b35920385024b546.png";